const constructValidationMessage = (error, displayFnName, reason) => {
  // Joi 17.x `error` on good validate is `undefined`, not `null`
  if (typeof error !== 'undefined' && reason) {
    const err = { reason };
    if (error) {
      const { details } = error;
      return {
        ...err,
        details: details.map(o => ({
          location: o.path.join('/'),
          message: o.message
        })),
        message: `${details.length} ${
          details.length === 1 ? 'error' : 'errors'
        } found in ${displayFnName}, please check error for details`
      };
    }
    return err;
  }
  return null;
};

export default constructValidationMessage;
